module.exports = __webpack_public_path__ + "img/bg-secondary.874eceac.svg";